import { Pipe, PipeTransform } from '@angular/core';
import { AssetDto, AssetVersionDto } from '@nusign/picflow-backend-types';
import { canDisplayAsset } from '../../lib/can-display-asset';

@Pipe({
  name: 'canDisplayAsset',
  standalone: true,
  pure: false,
})
export class CanDisplayAssetPipe implements PipeTransform {
  transform(asset: AssetDto, version?: AssetVersionDto) {
    return canDisplayAsset(asset, version);
  }
}
